import { render, staticRenderFns } from "./ZoneReportPhrases.vue?vue&type=template&id=308033d4&scoped=true"
import script from "./ZoneReportPhrases.vue?vue&type=script&lang=js"
export * from "./ZoneReportPhrases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308033d4",
  null
  
)

export default component.exports